"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IQMActionPicker = void 0;
const core_1 = require("@material-ui/core");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const WorkflowAction_1 = __importDefault(require("@opsbase/lib-workflow/WorkflowAction"));
const useIQMWorkflowDefinitions_1 = __importDefault(require("@opsbase/react-gql-hooks/integration-iqm/useIQMWorkflowDefinitions"));
const useIQMWorkflowFields_1 = __importDefault(require("@opsbase/react-gql-hooks/integration-iqm/useIQMWorkflowFields"));
const DataChooser_1 = __importDefault(require("@opsbase/web-data-choosers/DataChooser"));
const Divider_1 = __importDefault(require("@opsbase/web-layout/Divider"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Checkbox_1 = __importDefault(require("@opsbase/web-ui/Checkbox"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const Select_1 = __importDefault(require("@opsbase/web-ui/Select"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const yup_1 = require("yup");
const availableIssueFields = [
    'title',
    'flag',
    'placeId',
    'assetId',
];
const availableIssueFieldLabels = {
    title: 'title',
    flag: 'flag',
    placeId: 'place',
    assetId: 'asset',
};
function Loading() {
    return (react_1.default.createElement(Vertical_1.default, { gutter: true },
        react_1.default.createElement(core_1.CircularProgress, { style: { color: lib_palette_1.default.primary }, disableShrink: true, variant: "indeterminate", size: 40 })));
}
function Error() {
    return (react_1.default.createElement(Vertical_1.default, { gutter: true },
        react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('iqm-failed-to-load-workflows'))));
}
function AssociatedOperation({ includeAssociatedOperation, toggleIncludeOp, value, items, handleChangeFieldMapping, }) {
    return (react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, justify: 'flex-start' },
        react_1.default.createElement(Vertical_1.default, null,
            react_1.default.createElement(Checkbox_1.default, { label: 'Include Associated Operations?', checked: includeAssociatedOperation, onChange: toggleIncludeOp }),
            react_1.default.createElement(core_1.FormHelperText, null, "Must be sent to an External File field")),
        includeAssociatedOperation && (react_1.default.createElement(Pane_1.default, { grow: true },
            react_1.default.createElement(DataChooser_1.default, { value: value, items: items, multi: false, onChange: handleChangeFieldMapping('opUrl') })))));
}
function AddFieldToMapping({ selectedField, setSelectedField, fieldMappings, handleAddFieldMapping, }) {
    const fields = availableIssueFields.filter(f => !(f in fieldMappings));
    if (fields.length === 0) {
        return null;
    }
    return (react_1.default.createElement(Vertical_1.default, { gutter: true },
        react_1.default.createElement(Text_1.default, { style: { minWidth: 100 } }, lib_i18n_1.default.t('iqm-add-field-mapping')),
        react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, justify: 'flex-start' },
            react_1.default.createElement(Select_1.default, { value: selectedField, onChange: value => setSelectedField(value) }, fields.map(key => (react_1.default.createElement(MenuItem_1.default, { value: key, key: `option-${key}` },
                react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t(availableIssueFieldLabels[key])))))),
            react_1.default.createElement(Button_1.default, { disabled: selectedField === '', onClick: handleAddFieldMapping }, "Add"))));
}
function FieldMappings({ fieldMappings, fields, handleChangeFieldMapping, handleRemoveFieldMapping, }) {
    const opsbaseFields = Object.keys(fieldMappings).filter(k => k !== 'opUrl');
    return (react_1.default.createElement(Vertical_1.default, { gutter: true }, opsbaseFields.map(opsbaseField => (react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, justify: 'flex-start', key: `mapping-${opsbaseField}` },
        react_1.default.createElement(Text_1.default, { style: { minWidth: 100 } }, lib_i18n_1.default.t(availableIssueFieldLabels[opsbaseField])),
        react_1.default.createElement(Pane_1.default, { grow: true },
            react_1.default.createElement(DataChooser_1.default, { value: fields.filter(f => f.id === fieldMappings[opsbaseField]), items: fields.filter(f => {
                    return (f.type === 'Text' &&
                        (!Object.values(fieldMappings).includes(f.id) ||
                            f.id === fieldMappings[opsbaseField]));
                }), multi: false, onChange: handleChangeFieldMapping(opsbaseField) })),
        react_1.default.createElement(Button_1.default, { onClick: handleRemoveFieldMapping(opsbaseField) }, lib_i18n_1.default.t('iqm-remove-field-mapping')))))));
}
function Fields({ config, selectedField, setSelectedField, handleAddFieldMapping, handleChangeFieldMapping, handleRemoveFieldMapping, includeAssociatedOperation, toggleIncludeOp, }) {
    const { loading, data: fields, error, } = (0, useIQMWorkflowFields_1.default)({ variables: { workflowDefinitionId: config.workflowDefinitionId } });
    if (loading) {
        return react_1.default.createElement(Loading, null);
    }
    if (error || (!loading && !fields)) {
        return react_1.default.createElement(Error, null);
    }
    return (react_1.default.createElement(Vertical_1.default, { gutter: true },
        react_1.default.createElement(Text_1.default, { style: { minWidth: 100 } }, lib_i18n_1.default.t('iqm-field-mappings')),
        react_1.default.createElement(AddFieldToMapping, { selectedField: selectedField, setSelectedField: setSelectedField, fieldMappings: config.fieldMappings, handleAddFieldMapping: handleAddFieldMapping }),
        Object.keys(config.fieldMappings).length > 0 && (react_1.default.createElement(FieldMappings, { fieldMappings: config.fieldMappings, fields: fields, handleChangeFieldMapping: handleChangeFieldMapping, handleRemoveFieldMapping: handleRemoveFieldMapping })),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(AssociatedOperation, { includeAssociatedOperation: includeAssociatedOperation, toggleIncludeOp: toggleIncludeOp, value: fields.filter(f => String(f.id) === String(config.fieldMappings['opUrl'])), items: fields.filter(f => f.type === 'ExternalFile'), handleChangeFieldMapping: handleChangeFieldMapping })));
}
function IQMActionPickerUI(props) {
    const [selectedField, setSelectedField] = (0, react_1.useState)('');
    const { loading, data, error } = (0, useIQMWorkflowDefinitions_1.default)();
    const { action, onChangeAction, disabled = false } = props;
    const config = action === null || action === void 0 ? void 0 : action.workflowActionConfig;
    const [includeAssociatedOperation, setIncludeAssociatedOperation] = (0, react_1.useState)(config.fieldMappings['opUrl'] ? true : false);
    const handleChangeWorkflowDefinitionId = (0, react_1.useCallback)((value) => {
        config.workflowDefinitionId = value[0].id;
        config.fieldMappings = {};
        action.workflowActionConfig = config;
        onChangeAction(new WorkflowAction_1.default(action));
    }, [config, action, onChangeAction]);
    const handleChangeFieldMapping = (0, react_1.useCallback)((opsbaseField) => (value) => {
        config.fieldMappings[opsbaseField] = value[0].id;
        action.workflowActionConfig = config;
        onChangeAction(new WorkflowAction_1.default(action));
    }, [config, action, onChangeAction]);
    const handleAddFieldMapping = () => {
        if (selectedField in config.fieldMappings)
            return;
        config.fieldMappings[selectedField] = '';
        action.workflowActionConfig = config;
        onChangeAction(new WorkflowAction_1.default(action));
        setSelectedField('');
    };
    const handleRemoveFieldMapping = (opsbaseField) => () => {
        delete config.fieldMappings[opsbaseField];
        action.workflowActionConfig = config;
        onChangeAction(new WorkflowAction_1.default(action));
    };
    const toggleIncludeOp = () => {
        if (includeAssociatedOperation) {
            delete config.fieldMappings['opUrl'];
        }
        else {
            config.fieldMappings['opUrl'] = '';
        }
        action.workflowActionConfig = config;
        onChangeAction(new WorkflowAction_1.default(action));
        setIncludeAssociatedOperation(prev => !prev);
    };
    if (loading) {
        return react_1.default.createElement(Loading, null);
    }
    if (error || (!loading && !data)) {
        return react_1.default.createElement(Error, null);
    }
    return (react_1.default.createElement(Vertical_1.default, { gutter: true },
        react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, justify: 'flex-start' },
            react_1.default.createElement(Text_1.default, { style: { minWidth: 100 } }, lib_i18n_1.default.t('iqm-workflow-definition-id')),
            react_1.default.createElement(Pane_1.default, { grow: true },
                react_1.default.createElement(DataChooser_1.default, { value: data.filter(d => d.id === config.workflowDefinitionId), items: data, multi: false, onChange: handleChangeWorkflowDefinitionId }))),
        react_1.default.createElement(Divider_1.default, null),
        config.workflowDefinitionId && (react_1.default.createElement(Fields, { config: config, selectedField: selectedField, setSelectedField: setSelectedField, handleAddFieldMapping: handleAddFieldMapping, handleChangeFieldMapping: handleChangeFieldMapping, handleRemoveFieldMapping: handleRemoveFieldMapping, includeAssociatedOperation: includeAssociatedOperation, toggleIncludeOp: toggleIncludeOp }))));
}
const IQMConfigSchema = (0, yup_1.object)({
    domain: (0, yup_1.string)().min(1).required(),
    userAgent: (0, yup_1.string)().min(1).required(),
    apiKey: (0, yup_1.string)().min(1).required(),
});
function IQMActionPicker(props) {
    var _a;
    const { isIQMEnabled, settings } = props;
    if (!isIQMEnabled) {
        return (react_1.default.createElement(Vertical_1.default, { gutter: true },
            react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('iqm-not-enabled'))));
    }
    try {
        IQMConfigSchema.validateSync((_a = settings === null || settings === void 0 ? void 0 : settings.integrations) === null || _a === void 0 ? void 0 : _a.iqm);
    }
    catch (error) {
        return (react_1.default.createElement(Vertical_1.default, { gutter: true },
            react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('iqm-not-configured'))));
    }
    return react_1.default.createElement(IQMActionPickerUI, Object.assign({}, props));
}
exports.IQMActionPicker = IQMActionPicker;
exports.default = IQMActionPicker;
